export const GTMEvent = {
  AUTH: 'auth',
  METRIC_UPDATE: 'metric_update',
  CHECKOUT_PAGE_VIEW: 'checkout_page_view',
  CHECKOUT_SUCCESS: 'checkout_success'
};
